import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDisableHistoryGestures } from '../../hooks/useDisableHistoryGestures';
import Navbar from './Navbar';
import { NavbarActionsSlotContext, NavbarLeftActionsSlotContext } from './NavbarPageActions';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useDisableHistoryGestures();
  const location = useLocation();
  const usesFixedDetailNavbar =
    /^\/order\/[^/]+$/.test(location.pathname) ||
    /^\/bundle-work-order\/[^/]+$/.test(location.pathname) ||
    /^\/inventory-transfers\/[^/]+$/.test(location.pathname) ||
    /^\/receive\/shipment\/[^/]+(?:\/item\/[^/]+)?$/.test(location.pathname) ||
    /^\/tasks\/[^/]+$/.test(location.pathname);

  const [actionsSlot, setActionsSlot] = useState<HTMLDivElement | null>(null);
  const [leftActionsSlot, setLeftActionsSlot] = useState<HTMLDivElement | null>(null);
  const isBundleWorkList = location.pathname === '/bundle-work-orders';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <NavbarActionsSlotContext.Provider value={actionsSlot}>
      <NavbarLeftActionsSlotContext.Provider value={leftActionsSlot}>
        <div className={`app-frame${isBundleWorkList ? ' bundle-work-list-nav' : ''}`}>
          {!usesFixedDetailNavbar && (
            <Navbar
              actionsSlotRef={setActionsSlot}
              leftActionsSlotRef={setLeftActionsSlot}
            />
          )}
          <div
            className="app-shell"
            style={{ paddingTop: usesFixedDetailNavbar ? 0 : 'var(--app-navbar-offset, 4rem)' }}
          >
            {children}
          </div>
        </div>
      </NavbarLeftActionsSlotContext.Provider>
    </NavbarActionsSlotContext.Provider>
  );
};

export default Layout;
